import SalePlan from './sale-plan';
import GroupOfProduct from './group-product';
import Panel from './panel';
import BigbossPanel from 'datapanelInAcore/pages/big-boss-panel';

export default [
  {
    menuId: 92,
    menuCode: '004-2',
    title: '',
    path: '/',
    component: Panel,
  },
  {
    menuId: 92,
    menuCode: '004-2',
    title: '管理销售计划',
    path: '/sale-plan',
    component: SalePlan,
  },
  {
    menuId: 92,
    menuCode: '004-2',
    title: '商品分组',
    path: '/product-group',
    component: GroupOfProduct,
  },
  {
    menuId: 93,
    menuCode: '004-3',
    title: '场域监控',
    path: '/big-boss-panel',
    component: BigbossPanel,
  },
];
